/**
 * 애플리케이션 레이아웃 컴포넌트
 *
 * 주요 기능:
 * - 전체 페이지 구조 정의 (Header, Main, Footer, BottomPlayer)
 * - React Router Outlet을 통한 페이지 콘텐츠 렌더링
 * - 오디오 플레이어 표시 여부에 따른 동적 레이아웃 조정
 * - 페이지 이동 시 자동 스크롤 최상단 이동
 *
 * 레이아웃 구조:
 * - Header: 상단 네비게이션 바
 * - Main: 페이지 콘텐츠 영역 (Outlet)
 * - Footer: 하단 푸터
 * - BottomPlayer: 하단 고정 오디오 플레이어
 *
 * 사용처: router/index.tsx의 최상위 레이아웃
 */

import { styled } from "styled-components";
import Header from "./Header";
import { Footer } from "./Footer";
import { Outlet } from "react-router-dom";
import { BottomPlayer } from "../player/BottomPlayer";
import { useAudioPlayerStore } from "@/stores/audioPlayerStore";
import { useTheme } from "styled-components";
import { useScrollToTop } from "@/hooks/useScrollToTop";

/**
 * Layout 컴포넌트
 *
 * 애플리케이션의 전체 레이아웃을 정의하고 페이지 간 공통 요소를 제공
 *
 * @returns 헤더, 메인 콘텐츠, 푸터, 오디오 플레이어를 포함한 레이아웃
 */
const Layout = () => {
  const { currentTrack } = useAudioPlayerStore();
  const theme = useTheme();
  const isPlayerVisible = !!currentTrack;

  // 페이지 이동 시 스크롤 최상단으로 이동
  useScrollToTop();

  return (
    <StyledLayout $playerPadding={isPlayerVisible ? theme.playerHeight : 0}>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <BottomPlayer />
    </StyledLayout>
  );
};

export default Layout;

// Styled Components
const StyledLayout = styled.div<{ $playerPadding: number }>`
  position: relative;
  min-height: 100vh;
  padding-top: 92px;

  main {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
  }
`;
